import api from './api';

const API_URL = '/';

export const getTransactions = async () => {
    const response = await api.get(`${API_URL}CopaymentAcquirer/transactions`);
    return response.data;
};
